<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import DatePicker from "vue2-datepicker";


export default {
    components: { Layout, PageHeader, DatePicker },
    page: {
        title: "Collectibles",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
   
    data() {
        return {
            title: "Collectibles",
            items: [
                {
                    text: "Fan Experience",
                },
                {
                    text: "Collectibles",
                    active: true,
                },
            ],
            error: null,
            showModal: false,
            modalData: {},
            tableData: [],
            showErrorMessage: false,
            filterClicked: false,
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: ['name', 'slug','type'],
            sortBy: "start_time",
            showTable: false,
            sortDesc: true,
            totalCollectibles: 0,
            totalClaimed: 0,
            totalImagePercent: 0,
            daterange: "",
            selectedTenant: "",
            fields: [
                {
                  key:"id",
                  label: "ID",
                  sortable: true,
                },
                {
                    key: "name",
                    label: "Name",
                    sortable: false,
                },
                {
                    key: "state",
                    label: "State",
                    sortable: false,
                },
                {
                    key: "type",
                    label: "Type",
                    sortable: false,
                },
                {
                    key: "start_time",
                    label: "Start Time",
                    sortable: true,
                },
                {
                    key: "slug",
                    label: "Slug",
                    sortable: false,
                },
                {
                    key: "active",
                    label: "Active",
                    sortable: false,
                },
                {
                    key: "collectibles_cnt",
                    label: "Collectibles",
                    sortable: true,
                },
                {
                    key: "image_cnt",
                    label: "Image",
                    sortable: true,
                },
                {
                    key: "image_percent",
                    label: "Image Percent",
                    sortable: true,
                },
                {
                    key: "claimed",
                    label: "Claimed",
                    sortable: false,
                },
            ],
            isBusy: false,
            editingslugId: null,
            editedSlug: '',
            isSavingSlug: false,
            tenantStats: [],
            totalSum: 0.0,
            totalCollectiblesWithImages: 0,
            totalTenantCollectibles: 0,
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        }
    },
    methods: {
          async getNftPacks() {
            try {
                this.toggleBusy();
                let filters = this.getFilter()
                const response = await Monitor.getNftPacks(filters);

                this.tableData = response.data.list;
                this.totalRows = this.tableData.length;

                this.totalCollectibles = response.data.total_collectibles || 0;
                this.totalClaimed = response.data.total_claimed || 0;
                this.totalImagePercent = Math.floor((response.data.total_image_percent || 0) * 100) / 100;
                let tenant_stats = response.data.tenant_stats
                let totalSum = 0.0;
                let totalCollectiblesWithImages = 0;
                let totalTenantCollectibles = 0;
                this.tenantStats = Object.fromEntries(
                    Object.entries(tenant_stats).filter(([ , stats ]) => {
                      const collectibles_with_image = Number(stats.collectibles_with_image) || 0;
                      const sum = Number(stats.sum) || 0;

                      if (collectibles_with_image > 0) {
                        totalSum += sum;
                        totalTenantCollectibles += stats.total_collectibles;
                        totalCollectiblesWithImages += collectibles_with_image;
                        return true;
                      }

                      return false;
                    })
                );
              this.totalSum = Math.round(totalSum * 100) / 100;
              this.totalCollectiblesWithImages = totalCollectiblesWithImages
              this.totalTenantCollectibles = totalTenantCollectibles

              this.toggleBusy();
              this.toggleTableVisibility();
            } catch (error) {
                this.toggleBusy();
                console.error("Error fetching nft packs:", error);
                this.error = error.response?.data?.error || error.message;
                this.tableData = [];
            }
        },

        getFilter(){

          let filter = '';

          if(this.selectedTenant){
            filter +='tenant='+this.selectedTenant
          }

          if (this.daterange && this.daterange.length === 2) {
            const [start, end] = this.daterange;
            const dateFrom = this.formatLocalDate(start);
            const dateTo = this.formatLocalDate(end);
            filter += `&date_from=${dateFrom}&date_to=${dateTo}`;
          }

          return filter;
        },
        
        toggleTableVisibility() {
            this.showTable = true;
        },
      
        toggleBusy() {
            this.isBusy = !this.isBusy;
        },

        cancelEditSlug() {
          this.editingslugId = null;
          this.editedSlug = '';
        },

        enableEditSlug(collectibleId, currentSlug) {
          this.editingslugId = collectibleId;
          this.editedSlug = currentSlug || '';
        },

        async editNft(item, edit = 'slug'){
          const nftId = item.id
          const tenant = nftId.split('-')[0];

          if(edit == 'slug'){
            this.isSavingSlug = true

            try {
              const response = await Monitor.editNft({
                id: nftId,
                slug: this.editedSlug,
                tenant: tenant,
                csrf_token: this.csrf_token
              });

              if (response.data) {
                // Update the table data locally
                const target = this.tableData.find(row => row.id === nftId);
                if (target) {
                  this.$set(target, 'slug', this.editedSlug);
                }
                this.cancelEditSlug();
              } else {
                this.failedmsg('Failed to save slug.');
              }

            } catch (error) {
              console.error('Error saving slug:', error);
              let error_msg = error.response?.data?.error || "An error occurred";
              this.failedmsg(error_msg);
            }finally {
              this.isSavingSlug= false;
            }
          }else if(edit == 'status'){

            try {
              const response = await Monitor.editNft({
                id: nftId,
                active: item.active,
                tenant: tenant,
                csrf_token: this.csrf_token
              });

              if (response.data) {
                // Update the table data locally
              } else {
                this.failedmsg('Failed to save slug.');
              }
            } catch (error) {
              this.$set(item, 'active', item.active ? 0 : 1);
              console.error('Error saving slug:', error);
              let error_msg = error.response?.data?.error || "An error occurred";
              this.failedmsg(error_msg);
            }
          }
        },

        editActiveStatus(nftData, value){
          nftData.active = value === true ? 1 : 0;
          this.editNft(nftData, 'status')
        },

        clearFilters(){
          this.daterange = '';
        },

        onFiltered(filteredItems) {
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
    },
    watch:{
      daterange(newValue) {
        if (newValue) {
          this.tenantStats = []
          this.totalRows = 0
          this.currentPage = 1
          this.getNftPacks()
        }
      }
    },
    middleware: "authentication",
};
</script>
<template>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body text-center">
              <div class="row">
                <div class="col-md-4 d-inline-flex align-items-center">
                  <label class="control-label form-label" style="width: 180px">Choose Dates</label>
                  <date-picker
                      v-model="daterange"
                      range
                      append-to-body
                      lang="en"
                      confirm
                  ></date-picker>
                </div>
                <div class="col-md-4 d-inline-flex align-items-center">
                  <button class="btn btn-outline-danger btn-sm" @click="clearFilters">
                    <i class="mdi mdi-filter-remove me-1"></i>
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4" v-if="!isBusy">
          <div class="col-md-3">
              <div class="card">
                  <div class="card-body text-center">
                      <p class="card-text fs-4 fw-bold text-primary">{{ formatNumber(totalCollectibles) }}</p>
                      <h3 class="card-title">Total Collectibles</h3>
                  </div>
              </div>
          </div>
          <div class="col-md-3">
              <div class="card">
                  <div class="card-body text-center">
                  <p class="card-text fs-4 fw-bold text-success">{{ formatNumber(totalCollectiblesWithImages) }} ({{ totalImagePercent }}%)</p>
                      <h3 class="card-title">Total Collectibles with Images</h3>
                  </div>
              </div>
          </div>
          <div class="col-md-3">
              <div class="card">
                  <div class="card-body text-center">
                      <p class="card-text fs-4 fw-bold text-warning">{{ formatNumber(totalClaimed) }}</p>
                      <h3 class="card-title">Total Claimed</h3>
                  </div>
              </div>
          </div>
          <div class="col-md-3">
            <div class="card">
              <div class="card-body text-center">
                <p class="card-text fs-4 fw-bold text-primary">{{ formatNumber(totalSum.toFixed(2)) }}</p>
                <h3 class="card-title">Total Revenue (EUR)</h3>
              </div>
            </div>
          </div>
      </div>
      <div v-else>
        <div class="card">
          <div class="card-body d-flex align-items-center justify-content-center">
            <b-spinner large></b-spinner>
          </div>
        </div>
      </div>

      <div class="row" v-if="tenantStats">
        <div class="col-md-12" >
          <div class="card">
            <div class="card-body ">

              <div class="row">
                <div class="col-sm-12">
                  <h5>Total Collectibles Report per Tenant</h5>
                </div>
              </div>

              <table class="table table-hover table-condensed my-3" >
                <thead>
                  <tr>
                    <th>Tenant</th>
                    <th style="text-align:right">Total Collectibles</th>
                    <th style="text-align:right">Collectibles With Image</th>
                    <th style="text-align:right">Revenue (EUR)</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="!isBusy">
                    <tr v-for="(stats, tenant) in tenantStats" :key="tenant" >
                      <td>{{ tenant }}</td>
                      <td style="text-align:right">{{ formatNumber(stats.total_collectibles) }}</td>
                      <td style="text-align:right">{{ formatNumber(stats.collectibles_with_image) }}</td>
                      <td style="text-align:right">{{ formatNumber(stats.sum.toFixed(2)) }}</td>
                    </tr>
                    <tr class="text-strong border-top-1" >
                      <td>TOTALS:</td>
                      <td style="text-align:right">{{formatNumber(totalCollectiblesWithImages)}}</td>
                      <td style="text-align:right">{{formatNumber(totalCollectiblesWithImages)}}</td>
                      <td style="text-align:right">{{formatNumber(totalSum.toFixed(2))}}</td>
                    </tr>
                  </template>

                  <tr v-else>
                    <td colspan="4">
                      <div class="card-body d-flex align-items-center justify-content-center">
                        <b-spinner large></b-spinner>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-if="showTable">
                        <div class="row mt-4">

                            <div class="col-sm-12 pt-0">
                              <h5>Collectibles Details</h5>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                                    </label>
                                </div>
                            </div>
                           
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                show-empty
                                empty-text="No Data Found"
                                @filtered="onFiltered"
                            >

                              <template v-slot:cell(id)="data">
                                <router-link
                                    :to="{ path: `/games/pack_details/${data.item.id}` }"
                                    class="text-decoration-none text-primary"
                                >
                                  {{ data.item.id }}
                                </router-link>
                              </template>

                              <template #cell(state)="data">
                                <span
                                    :class="{
                                        'text-success fw-bold': data.value === '1',
                                        'text-danger fw-bold': data.value === '0'
                                    }"
                                >
                                    {{ data.value === '1' ? 'Claimable' : 'Not Available' }}
                                </span>
                               </template>

                              <template v-slot:cell(slug)="data">

                                <div v-if="editingslugId !== data.item.id">
                                        <span @click="enableEditSlug(data.item.id, data.item.slug)">
                                          <span v-if="data.item.slug" style="white-space: pre-wrap">{{data.item.slug}}</span>
                                          <a href="javascript:void(0);" title="Edit Slug" class="px-2 text-primary"><i class="uil uil-pen font-size-18"></i></a>
                                        </span>
                                </div>
                                <div v-else>
                                  <b-form-textarea
                                      v-model="editedSlug"
                                      rows="2"
                                      max-rows="6"
                                      class="mb-2"
                                      placeholder="Enter Slug"
                                      @keyup.enter.ctrl="editNft(data.item, 'slug')"
                                  />
                                  <b-button size="sm" variant="success" @click="editNft(data.item, 'slug')" class="me-1" :disabled="isSavingSlug" >
                                    <span v-if="!isSavingSlug">Save</span>
                                    <b-spinner small v-else label="Saving..."></b-spinner>
                                  </b-button>
                                  <b-button size="sm" variant="danger" @click="cancelEditSlug">Cancel</b-button>
                                </div>
                              </template>

                              <template #cell(image_percent)="data">
                                    <span>
                                      {{ Math.floor((data.value || 0) * 100) / 100 }}
                                    </span>
                              </template>

                              <template #cell(active)="data">
<!--                                  <span
                                      :class="{
                                          'text-success': data.value === 1,
                                          'text-danger': data.value === 0,
                                      }"
                                  >
                                      <i v-if="data.value === 1" class="uil uil-check fa-2x text-success"></i>
                                      <i v-else-if="data.value === 0" class="uil uil-times fa-2x text-danger"></i>

                                  </span>-->
                                  <b-form-checkbox-group>
                                    <div class="form-check form-switch form-switch-lg mb-3">
                                      <input v-model="data.value" @change="editActiveStatus(data.item, data.value)"
                                             type="checkbox"
                                             class="form-check-input"
                                             id="editActiveStatus"
                                      />
                                    </div>
                                  </b-form-checkbox-group>
                              </template>

                                <template #table-busy>
                                    <div class="text-center text-black my-2">
                                        <b-spinner class="align-middle text-primary"></b-spinner>
                                        <strong class="text-primary">Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                ></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- <div v-else class="text-center mt-4">
                        <strong>Use the filter to display the data</strong>
                    </div> -->
                </div>
            </div>
        </div>
    </Layout>
</template>
